import { ReactNode } from "react"
import { TextField, TextFieldVariants } from "@mui/material"
import { Control, Controller, FieldValues, Path } from "react-hook-form"

interface ControlledInputProps<T extends FieldValues> {
  formInputStyling?: object
  name: Path<T>
  label?: string
  type?: string
  props?: object
  control: Control<T>
  endAdornment?: ReactNode
  startAdornment?: ReactNode
  variant?: TextFieldVariants
  placeholder?: string
  multiline?: boolean
}

const ControlledTextInput = <T extends FieldValues>({
  formInputStyling,
  control,
  name,
  label,
  type,
  placeholder,
  variant,
  endAdornment,
  startAdornment,
  multiline,
}: ControlledInputProps<T>) => {
  return (
    <>
      <Controller
        control={control}
        name={name}
        render={({ field, fieldState }) => (
          <TextField
            multiline={multiline ? true : false}
            rows={multiline ? 4 : undefined}
            sx={formInputStyling}
            type={type}
            label={label}
            placeholder={placeholder}
            inputRef={field.ref}
            {...field}
            variant={variant}
            InputProps={{
              startAdornment: startAdornment,
              endAdornment: endAdornment,
            }}
            error={fieldState.invalid}
            helperText={fieldState.error?.message}
          />
        )}
      />
    </>
  )
}

export default ControlledTextInput
